module.exports = __webpack_public_path__ + "868369d0abc03f939ead4f78054a534b.png";